import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Note: cn function also available in src/lib/cn.ts for TypeScript files
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
